module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"more":"Zeig mehr"},"en":{"more":"Show more"},"it":{"more":""},"lt":{"more":"Daugiau"},"pl":{"more":"Pokaż więcej"}}')
  delete Component.options._Ctor
}
